import backgroundVideo from '../images/homepage.mp4'
import './About.css'
export default function About(){
    return <>
    <div className="page">
    <video autoPlay loop muted playsInline className="background-video">
        <source src={backgroundVideo} type="video/mp4" />
    </video>
    <div className='content_in_abt'>
    <h1>Fly prices</h1>
    <h1>and</h1>
    <h1>HIGH quality!</h1>
    <p>At High and Fly, we are dedicated to providing our customers with the highest quality tobacco products. Our team of experts carefully selects and tests each product to ensure that it meets our strict standards for quality, flavor, and overall experience. Whether you're a seasoned smoker or new to the world of smoke, we have something for everyone. We pride ourselves on our commitment to customer satisfaction and strive to create a welcoming and inclusive environment for all. Come visit us today and experience fly prices and HIGH quality!</p>
    </div>
    </div>
    </>
}